export const DEFAULT_USER_VALUES = {
  PASSWORD: '123456',
  PHONE: '+966555555555'
} as const;

export const AUTH_ERROR_CODES = {
  EMAIL_IN_USE: 'auth/email-already-in-use',
  INVALID_EMAIL: 'auth/invalid-email',
  WEAK_PASSWORD: 'auth/weak-password',
  NETWORK_ERROR: 'auth/network-request-failed',
  TOO_MANY_REQUESTS: 'auth/too-many-requests',
  OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
  INVALID_ARGUMENT: 'auth/invalid-argument',
  USER_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password'
} as const;

export const AUTH_ERROR_MESSAGES = {
  [AUTH_ERROR_CODES.EMAIL_IN_USE]: 'This email is already registered',
  [AUTH_ERROR_CODES.INVALID_EMAIL]: 'Invalid email address',
  [AUTH_ERROR_CODES.WEAK_PASSWORD]: 'Password must be at least 6 characters',
  [AUTH_ERROR_CODES.NETWORK_ERROR]: 'Network error. Please check your connection',
  [AUTH_ERROR_CODES.TOO_MANY_REQUESTS]: 'Too many attempts. Please try again later',
  [AUTH_ERROR_CODES.OPERATION_NOT_ALLOWED]: 'Email/password accounts are not enabled',
  [AUTH_ERROR_CODES.INVALID_ARGUMENT]: 'Invalid signup information provided',
  [AUTH_ERROR_CODES.USER_NOT_FOUND]: 'No account found with this email',
  [AUTH_ERROR_CODES.WRONG_PASSWORD]: 'Incorrect password',
  default: 'An unexpected error occurred. Please try again.'
} as const;